import * as React from 'react';
import { Eye, X } from 'lucide-react';
import { Button } from '../../ui/button';

export interface ImpersonationBannerProps {
  /** Label for the disconnect button */
  disconnectLabel: string;
  /** The message to display, e.g. "You are viewing as **BestBuy** tenant admin" */
  message: React.ReactNode;
  /** Callback when the disconnect button is clicked */
  onDisconnect: () => void;
}

export function ImpersonationBanner({
  disconnectLabel,
  message,
  onDisconnect,
}: ImpersonationBannerProps): React.JSX.Element {
  return (
    <div className="bg-gradient-to-r from-orange-500 to-amber-500 text-white px-4 py-2 flex items-center justify-between text-sm font-medium">
      <div className="flex items-center gap-2">
        <Eye className="h-4 w-4" />
        <span>{message}</span>
      </div>
      <Button className="text-white hover:bg-white/20 gap-1" onClick={onDisconnect} size="sm" variant="ghost">
        <X className="h-4 w-4" />
        {disconnectLabel}
      </Button>
    </div>
  );
}
